import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../components/Header";
import { SubscriptionInfo } from "../components/profile/SubscriptionInfo";
import { useAnalytics } from "../lib/analytics";
import { useClientTranslations } from "../lib/i18n/client";
import styles from "./SubscriptionSettings.module.css";

export function SubscriptionSettings() {
	const { t, direction } = useClientTranslations("profile");
	const { logEvent } = useAnalytics();
	const navigate = useNavigate();

	useEffect(() => {
		logEvent("subscription_settings_page_viewed");
	}, [logEvent]);

	return (
		<div className={styles.wrapper}>
			<Header />
			<main className={styles.main} dir={direction}>
				<div className={styles.container}>
					<div className={styles.heading}>
						<button
							type="button"
							className={styles.backButton}
							onClick={() => {
								logEvent("subscription_back_clicked");
								navigate("/settings");
							}}
							aria-label={t("settings.back")}
						>
							&#8249;
						</button>
						<h1 className={styles.title}>{t("settings.cards.subscription")}</h1>
						<p className={styles.subtitle}>
							{t("settings.subscriptionSubtitle")}
						</p>
					</div>

					<SubscriptionInfo />
				</div>
			</main>
		</div>
	);
}
